import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CuadroDatos from "../UI/CuadroDatos.js";
import BotoneraFiltros from "../UI/BotoneraFiltros.js";
import Paginador from "../UI/Paginador.js";
import TablaDatos from "../UI/TablaDatos.js";
import * as AgrupacionesTorneos from "../constantes/AgrupacionesTorneos.js";
import * as UI from "../constantes/UI.js";
import { ListaPartidos } from "../constantes/Filtros.js";
import * as Localia from "../constantes/Localia.js";
import * as DataPartidos from "../data/DataPartidos.js";
import * as Fecha from "../funciones/FuncionesFecha.js";
import { getIdRival, getIdTipoRival } from "../funciones/FuncionesHistoriales.js";
import { NombreEquipoRelativo } from "../funciones/FuncionesEquipo.js";
import useGetListaURL from "../../hooks/useGetListaURL.js";
import styles from "./PartidosClub.module.css";

const filtroPartidos = [
  {
    codigo: ListaPartidos.TOTALES,
    descripcion: "Totales",
  },
  {
    codigo: AgrupacionesTorneos.LIGAS_NACIONALES,
    descripcion: "Liga Nacional",
  },
  {
    codigo: AgrupacionesTorneos.COPAS_NACIONALES,
    descripcion: "Copas Nacionales",
  },
  {
    codigo: AgrupacionesTorneos.INTERNACIONALES,
    descripcion: "Internacionales",
  },
  { codigo: ListaPartidos.AMISTOSOS, descripcion: "Amistosos" },
];

const PartidosClub = (props) => {
  const idClub = props.club && props.club.id;
  const tipoRival = props.rival && getIdTipoRival(props.rival);
  const idRival = props.rival && getIdRival(props.rival);
  const [partidos, setPartidos] = useState([]);
  const [cantPaginas, setCantPaginas] = useState(null);
  const [pagina, setPagina] = useState(0);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const [filtro, setFiltro] = useState(ListaPartidos.TOTALES);

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const getTotalPartidos = async () => {
      let total = await DataPartidos.GetTotalPartidosClub(idClub, filtro, tipoRival, idRival);
      if (total !== null && total !== Promise.resolve(total)) {
        setCantPaginas(Math.floor(total / UI.PARTIDOS_X_PAGINA) + 1);
      }
    };
    if (idClub !== null) {
      getTotalPartidos();
    }
  }, [fetchData, idClub, filtro, tipoRival, idRival]);

  useEffect(() => {
    if (idClub) {
      const idBusqueda = idRival ? idRival : idClub;
      const path = DataPartidos.PathClubTipoRival(idClub, tipoRival, idRival);
      if (path) {
        const url = DataPartidos.URLListaPartidos(path, idBusqueda, filtro, pagina, UI.PARTIDOS_X_PAGINA);
        fetchData(url, setPartidos);
      }
    } else {
      setPartidos([]);
    }
  }, [fetchData, idClub, filtro, tipoRival, idRival, pagina]);

  const onFiltroElegido = (filtro) => {
    setPagina(0);
    setFiltro(Number(filtro));
    props.onFiltroElegido && props.onFiltroElegido(filtro);
  };

  const onPaginaElegida = (pagina) => {
    setPagina(pagina);
  };

  const nombreRival = (partido) => {
    if (partido.localia === Localia.LOCAL) {
      return NombreEquipoRelativo(
        partido.equipoVisitante,
        partido.categoria,
        partido.equipoLocal.pais
      );
    } else {
      return NombreEquipoRelativo(
        partido.equipoLocal,
        partido.categoria,
        partido.equipoVisitante.pais
      );
    }
  };

  const condicionPartido = (partido) => {
    if (partido.neutral) {
      return Localia.NEUTRAL;
    } else {
      return partido.localia;
    }
  }

  const resultadoPartido = (partido) => {
    if (partido.resultadoLocal === null || partido.resultadoVisitante === null) {
      return "-";
    } else if (partido.localia === Localia.LOCAL) {
      return partido.resultadoLocal + " - " + partido.resultadoVisitante;
    } else if (partido.localia === Localia.VISITANTE) {
      return partido.resultadoVisitante + " - " + partido.resultadoLocal;
    } else {
      return "-";
    }
  };

  return (
      <CuadroDatos
        titulo="Partidos"
        isCargando={isCargando}
        errores={erroresGetLista}
      >
      <BotoneraFiltros
        filtros={filtroPartidos}
        selected={filtro}
        onFiltroElegido={onFiltroElegido}
        onResetPagina={setPagina}
      />
      {partidos && !isCargando && (
        <React.Fragment>
          <TablaDatos
            estilo={`${styles.tablaPartidos}`}
            lista={partidos}
            textoVacia={
              idRival
                ? "No hay partidos cargados entre los clubes"
                : "No hay partidos cargados para el club"
            }
          >
            <tbody>
              <tr className={`${styles.titulo}`} key="0">
                <td className={`${styles.fecha}`}>Fecha</td>
                <td className={`${styles.torneo}`}>Torneo</td>
                <td className={`${styles.rival}`}>Rival</td>
                <td className={`${styles.condicion}`}>Cond.</td>
                <td className={`${styles.resultado}`}>Res.</td>
              </tr>
              {partidos &&
                partidos.map((partido) => (
                  <tr key={partido.id}>
                    <td>
                      {Fecha.CamposToFechaCorta(
                        partido.anioPartido,
                        partido.mesPartido,
                        partido.diaPartido
                      )}
                    </td>
                    <td>{partido.motivo}</td>
                    <td>{nombreRival(partido)}</td>
                    <td className={`${styles.condicion}`}>
                      {condicionPartido(partido)}
                    </td>
                    <td className={`${styles.resultado}`}>
                      <Link
                        to={"/partido/" + partido.id}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {resultadoPartido(partido)}
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TablaDatos>
          <Paginador
            cantPaginas={cantPaginas}
            cantBotones="5"
            paginaActual={pagina}
            onPaginaElegida={onPaginaElegida}
          />
        </React.Fragment>
      )}
    </CuadroDatos>
  );
};

export default PartidosClub;
